var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{attrs:{"vertical":"","pills":""}},[_c('b-tab',{attrs:{"title":"Introduction"}},[_c('ttIntroduction')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Simplification"}},[_c('simplification')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035ba174","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/truth-tables.vue
// module id = 368
// module chunks = 1